module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.getActiveAmount > 0) ? _c('div', {
    attrs: {
      "id": "banner"
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("A Forecast is active."), _c('span', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v("click here")]), _vm._v(" to learn more")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38a8f1ce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/ForecastBanner.vue
// module id = 3124
// module chunks = 0